"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicToggle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _ = require("..");
var _reactI18next = require("react-i18next");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    grayCircle: {
      backgroundColor: _pittaModules.DarkColors.primary["4"],
      borderRadius: "50%",
      width: 28,
      height: 28,
      position: "relative"
    },
    blueCircle: {
      backgroundColor: _pittaModules.DarkColors.primary["7"],
      borderRadius: "50%",
      width: 28,
      height: 28,
      position: "relative"
    },
    ctrlIcon: {
      position: "absolute",
      top: 4,
      right: 4
    },
    loadingIcon: {
      position: "absolute",
      top: 2,
      right: 2
    }
  };
});
var useSwitchStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: 64,
      height: 32,
      padding: 0,
      overflow: "visible"
    },
    switchBase: {
      padding: 2,
      cursor: "default"
    },
    track: {
      backgroundColor: _pittaModules.SemanticDarkColors.primary["0"],
      opacity: "1 !important",
      borderRadius: 20,
      position: "relative",
      "&:before, &:after": {
        display: "inline-block",
        position: "absolute",
        top: "55%",
        width: "50%",
        transform: "translateY(-50%)",
        textAlign: "center",
        fontSize: 12,
        fontFamily: "Roboto"
      },
      "&:before": {
        content: '"ON"',
        left: 1,
        opacity: 0,
        color: _pittaModules.LightColors.primary["0"]
      },
      "&:after": {
        content: '"OFF"',
        right: 1,
        color: _pittaModules.DarkColors.primary["4"]
      }
    },
    disabled: {
      "& + $track": {
        backgroundColor: "".concat(_pittaModules.SemanticDarkColors.primary["0"], "!important")
      }
    },
    checked: {
      "&$switchBase": {
        transform: "translateX(32px)",
        padding: 2,
        "&:hover": {
          backgroundColor: "rgba(24,90,257,0.08)"
        }
      },
      "& + $track": {
        background: "".concat(_pittaModules.SemanticDarkColors.primary["0"], " !important"),
        "&:before": {
          opacity: 1
        },
        "&:after": {
          opacity: 0
        }
      }
    }
  };
});
var MicToggle = function MicToggle(props) {
  var enableMic = props.enableMic,
    volume = props.volume,
    disabled = props.disabled,
    loading = props.loading,
    fullscreen = props.fullscreen,
    onToggleMic = props.onToggleMic;
  var theme = (0, _styles.useTheme)();
  var classes = useStyles(props);
  var switchClasses = useSwitchStyles();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    isHover /*, setIsHover*/ = _React$useState2[0];
  var _React$useState3 = _react.default.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    openMicTooltip = _React$useState4[0],
    setOpenMicTooltip = _React$useState4[1];
  var _React$useState5 = _react.default.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    openMicOffTooltip = _React$useState6[0],
    setOpenMicOffTooltip = _React$useState6[1];
  (0, _react.useEffect)(function () {
    if (mobile) {
      // mantis - 9178, dependency에 enableMic가 포함 -> enableMic가 변경이 있을 때 마다 실행되어 enableMic 제거.
      // mobile or app인 경우 처음시작을 제외하고 툴팁이 나오지 않도록 수정 (Leehj)
      setOpenMicTooltip(true);
      setTimeout(function () {
        return setOpenMicTooltip(false);
      }, 3000);
      setOpenMicOffTooltip(true);
      setTimeout(function () {
        return setOpenMicOffTooltip(false);
      }, 3000);
    }
  }, [mobile]);

  // loading 상태 추가되면서 PC에서 tooltip 자동으로 닫히지 않아 timer로직 추가
  (0, _react.useEffect)(function () {
    if (openMicTooltip) {
      var timer = setTimeout(function () {
        return setOpenMicTooltip(false);
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [openMicTooltip]);
  (0, _react.useEffect)(function () {
    if (openMicOffTooltip) {
      var timer = setTimeout(function () {
        return setOpenMicOffTooltip(false);
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [openMicOffTooltip]);

  // mic off인 상태
  var micOffIcon = (0, _react.useMemo)(function () {
    var button = /*#__PURE__*/_react.default.createElement(_.IconButton, {
      className: classes.ctrlIcon,
      disabled: disabled || loading,
      disableHover: mobile
    }, !mobile && openMicOffTooltip || mobile && isHover ? /*#__PURE__*/_react.default.createElement(_.MicOffHover, {
      style: {
        zIndex: 2,
        fontSize: 20
      }
    }) : /*#__PURE__*/_react.default.createElement(_.MicOff, {
      style: {
        zIndex: 2,
        fontSize: 20
      }
    }));
    if (loading) {
      button = /*#__PURE__*/_react.default.createElement("div", {
        className: classes.loadingIcon
      }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
        type: "spinningBubbles",
        width: 24,
        height: 24
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_.Tooltip, {
      open: openMicOffTooltip,
      onOpen: function onOpen() {
        return setOpenMicOffTooltip(true);
      },
      onClose: function onClose() {
        return setOpenMicOffTooltip(false);
      },
      disableTouchListener: mobile,
      disableHoverListener: mobile,
      PopperProps: {
        disablePortal: true,
        style: {
          width: 120
        },
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: mobile && openMicOffTooltip ? "0, -20px" : "0, -10px"
          },
          flip: {
            enabled: false
          }
        }
      },
      textCenter: true,
      title: /*#__PURE__*/_react.default.createElement(_.Typography, {
        category: "Default",
        variant: "Caption",
        style: {
          whiteSpace: "nowrap"
        }
      }, t("Start Voice Call")),
      placement: fullscreen ? "bottom" : "top"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.grayCircle
      // onTouchStart={() => (mobile ? setIsHover(true) : {})}
      ,
      onClick: function onClick() {
        // if (mobile) {
        //   setIsHover(false);
        // }
        onToggleMic();
      }
    }, button));
  }, [classes.ctrlIcon, classes.grayCircle, classes.loadingIcon, disabled, fullscreen, isHover, loading, mobile, onToggleMic, openMicOffTooltip, t]);

  // mic on인 상태
  var micIcon = (0, _react.useMemo)(function () {
    var button = /*#__PURE__*/_react.default.createElement(_.IconButton, {
      className: classes.ctrlIcon,
      disabled: loading
    }, /*#__PURE__*/_react.default.createElement(_.MicOn, {
      volume: volume,
      style: {
        zIndex: 2,
        fontSize: 20
      },
      fill: "none"
    }));
    if (loading) {
      button = /*#__PURE__*/_react.default.createElement("div", {
        className: classes.loadingIcon
      }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
        type: "spinningBubbles",
        width: 24,
        height: 24
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_.Tooltip, {
      open: openMicTooltip,
      onOpen: function onOpen() {
        return setOpenMicTooltip(true);
      },
      onClose: function onClose() {
        return setOpenMicTooltip(false);
      },
      disableTouchListener: mobile,
      disableHoverListener: mobile,
      PopperProps: {
        disablePortal: true,
        style: {
          width: 100
        },
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: mobile && openMicTooltip ? "0, -20px" : "0, -10px"
          },
          flip: {
            enabled: false
          }
        }
      },
      title: /*#__PURE__*/_react.default.createElement(_.Typography, {
        category: "Default",
        variant: "Caption"
      }, t("End Voice Call")),
      placement: fullscreen ? "bottom" : "top"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.blueCircle,
      onClick: function onClick() {
        onToggleMic();
      }
    }, button));
  }, [classes.blueCircle, classes.ctrlIcon, classes.loadingIcon, fullscreen, loading, mobile, onToggleMic, openMicTooltip, t, volume]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Switch.default, {
    classes: switchClasses,
    checked: enableMic,
    icon: micOffIcon,
    checkedIcon: micIcon,
    disabled: disabled || loading
  }));
};
exports.MicToggle = MicToggle;